export const DEFAULT_BONUS_AMOUNT = 15;

export const useBonusAmount = () => {
  const bonusAmount = DEFAULT_BONUS_AMOUNT;

  return { bonusAmount };
};
